module.exports = __webpack_public_path__ + "static/media/refi-home.30364e33.svg";